/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesFriendCategorySchema } from "./friendCategorySchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesUserFriendSchema = z.object({
  id: z.string().nullish(),
  userId: z.string().min(1),
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  friendId: z.string().min(1),
  get friend() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  createdAt: z.optional(z.iso.datetime()),
  note: z.string().max(500).nullish(),
  get category() {
    return goodLuckCoreEntitiesFriendCategorySchema.optional();
  },
});
